import { escapeRegExp } from 'lodash';

import { SftpEntry } from './types.ts';

export const formatFileSize = (size: number) => {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return +(size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export const fileMatchesPattern = (fileName: string, pattern: string) => {
    if (fileName === pattern) return true;

    if (pattern.includes('*')) {
        return new RegExp('^' + pattern.split('*').map(escapeRegExp).join('.*') + '$').test(fileName);
    }

    const dateRegex = new RegExp(
        '^' +
            escapeRegExp(pattern)
                .replaceAll('%Y', '\\d{4}')
                .replaceAll('%m', '\\d{2}')
                .replaceAll('%d', '\\d{2}')
                .replaceAll('%H', '\\d{2}')
                .replaceAll('%M', '\\d{2}')
                .replaceAll('%S', '\\d{2}') +
            '$'
    );

    return dateRegex.test(fileName);
};

// mirrors the backend's TransformerConfig: both keys may hold a single pattern or a list (historical reasons)
export const patternsFromTransformerConfig = (transformerConfig: string): string[] => {
    try {
        const config = JSON.parse(transformerConfig);
        const patterns = config.file_name_patterns ?? config.file_name_pattern ?? [];
        return (Array.isArray(patterns) ? patterns : [patterns]).filter(
            (pattern) => typeof pattern === 'string' && pattern.trim()
        );
    } catch {
        return [];
    }
};

// Same rule as the metadata service: SFTP files are listed newest first, the first file per pattern is used
export const newestFilePerPattern = (entries: SftpEntry[]) =>
    entries.filter(
        (entry, index) =>
            entry.matchingPattern &&
            entries.findIndex((other) => other.matchingPattern === entry.matchingPattern) === index
    );

export const readFileAsBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = reader.result as string;
            resolve(dataUrl.slice(dataUrl.indexOf(',') + 1));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
